// @ts-nocheck
import {EntityModel, EntityTypeModel} from '/ui/components/entitypicker/datasource/datamodel';
import {getEntitySectionIcon} from '/ui/components/entitypicker/entitylist/entityicon';
import {EntityItem} from '/ui/components/entitypicker/entitylist/entityitem';
import {EntityTypeSection} from '/ui/components/entitypicker/entitylist/entitytypesection';
import {SeeMoreItem} from '/ui/components/entitypicker/entitylist/seemoreitem';
import {yext} from '/ui/lib/msg';

import * as styles from '/ui/components/entitypicker/entitylist/itemlist.module.scss';

/**
 * @param {{
 *   type: !EntityTypeModel,
 *   onSelect: function(EntityModel): ?,
 *   onShowMore: function(string): ?,
 * }} props
 * @returns {React.ReactElement}
 */
const EntityTypeSectionContents = ({
  type,
  onSelect,
  onShowMore,
}) => {
  return <>
    {
      type.entities.map(entity => (
        <EntityItem
          entity={entity}
          entityType={type}
          onClick={() => onSelect(entity)}
          key={entity.id} />
      ))
    }
    {
      type.nextPageQuery
        && <SeeMoreItem onClick={() => onShowMore(type.nextPageQuery || '')} />
    }
  </>;
};

/**
 * @param {{
 *   types: !Array<!EntityTypeModel>,
 *   matchedEntityTypes: (!Set<number>|undefined),
 *   onSelect: function(EntityModel): ?,
 *   onShowMore: function(string): ?,
 *   collapsed: (boolean|undefined),
 * }} props
 * @returns {React.ReactElement}
 */
export const EntityList = ({
  types,
  onSelect,
  onShowMore,
  collapsed = true,
}) => {
  if (types.length === 0) {
    return <div className={styles.noResultsMessage}>{yext.msg('There were no entities found')}</div>;
  }

  if (types.length === 1) {
    return (
      <ul className={styles.entityFlatList}>
        <EntityTypeSectionContents
          type={types[0]}
          onSelect={onSelect}
          onShowMore={onShowMore} />
      </ul>
    );
  }

  return (
    <ul className={styles.entityFlatList}>
      {
        types.map(type => (
          <EntityTypeSection
            icon={getEntitySectionIcon(type)}
            label={`${type.label} (${type.total})`}
            key={type.id}
            typeId={type.id}
            initialCollapsed={collapsed}>
            <EntityTypeSectionContents
              type={type}
              onSelect={onSelect}
              onShowMore={onShowMore} />
          </EntityTypeSection>
        ))
      }
    </ul>
  );
};
